// extracted by mini-css-extract-plugin
export default {"qNumberAndTimer":"Exam_qNumberAndTimer__KZT0M","timerDiv":"Exam_timerDiv__pb2fK","examButtons":"Exam_examButtons__Ye4C5","questionNav":"Exam_questionNav__G3mFC"};